import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  FamilyOption,
  KinoSubscription,
} from '../../models/kino-subscription.model';

export const SubscriptionsApiActions = createActionGroup({
  source: 'Subscriptions API',
  events: {
    'Init Subscriptions Page Component': emptyProps(),
    'Fetch Active Subscription': emptyProps(),
    'Retrieved Active Subscription': props<{
      activeSubscription: KinoSubscription | null;
    }>(),
    'Fetch Former Subscriptions': emptyProps(),
    'Retrieved Former Subscriptions': props<{
      formerSubscriptions: ReadonlyArray<KinoSubscription>;
    }>(),
    'Fetch Family Members': emptyProps(),
    'Post Family Member': props<{ email: string }>(),
    'Delete Family Member': props<{ email: string }>(),
    'Retrieved Family Members': props<{
      memberEmails: ReadonlyArray<string>;
    }>(),
    Failed: props<{ errorMessage: string }>(),
  },
});

export const SubscriptionsActions = createActionGroup({
  source: 'Subscriptions',
  events: {
    'Add Active Subscription': props<{
      activeSubscription: KinoSubscription;
    }>(),
    'Remove Active Subscription': emptyProps(),
    'Change Family Option': props<{ familyOption: FamilyOption | null }>(),
    Reset: emptyProps(),
  },
});
